
interface HeroProps {
  onContactClick: () => void;
  onInquiryClick: () => void;
}

export default function Hero({ onContactClick, onInquiryClick }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16 sm:pt-20">
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <div className="inline-block mb-4 sm:mb-6 px-4 sm:px-6 py-2 bg-teal-600 text-white rounded-full text-xs sm:text-sm font-semibold">
              医療従事者専門サービス
            </div>
            
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              <span className="text-teal-600">論文検索・入手</span><br />
              代行サービス
            </h1>
            
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-700 mb-3 sm:mb-4 leading-relaxed font-medium">
              入手したい医学論文を、面倒な手続きなしで簡単に入手できるサービスです。
            </p>
            
            <p className="text-sm sm:text-base md:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              必要な論文を、専門スタッフが迅速かつ確実に調査・取得。<br className="hidden sm:inline" />
              要約（サマリー）・翻訳作成サービスをご用意しております。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start items-center mb-8 sm:mb-12 max-w-md sm:max-w-none mx-auto lg:mx-0">
              <button 
                onClick={onContactClick}
                className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-teal-600 text-white rounded-lg font-semibold text-sm sm:text-base md:text-lg hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-file-search-line text-lg sm:text-xl"></i>
                論文見積依頼（無料）
              </button>
              <button 
                onClick={onInquiryClick}
                className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white text-teal-600 border-2 border-teal-600 rounded-lg font-semibold text-sm sm:text-base md:text-lg hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-mail-line text-lg sm:text-xl"></i>
                お問合せ
              </button>
            </div>
            
            <div className="flex flex-wrap justify-center lg:justify-start gap-4 sm:gap-8 text-xs sm:text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-teal-600 text-base sm:text-xl"></i>
                <span>最短当日納期</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-teal-600 text-base sm:text-xl"></i>
                <span>国内外論文対応</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-teal-600 text-base sm:text-xl"></i>
                <span>クレジット決済可</span>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="hidden lg:block">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://www.inforesta.com/lp2/image/640475f42d3e87b5b2659522815ca81e.jpg"
                alt="医師が論文を読んでいる様子"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
